import { Video } from '@remotion/media';
import { useHasVideoEffects, useVideoEffectDescriptors } from './VideoEffectsContext';

/** Primary footage only. Keep decoder fallback from silently dropping effects. */
export function EffectsVideo(props: React.ComponentProps<typeof Video>) {
  const effects = useVideoEffectDescriptors();
  const hasEffects = useHasVideoEffects();
  return <Video {...props} effects={effects} disallowFallbackToOffthreadVideo={hasEffects || props.disallowFallbackToOffthreadVideo} />;
}
